
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER',
  UNKNOWN: 'UNKNOWN'
} as const

export type Gender = (typeof Gender)[keyof typeof Gender]


export const MobilePlatform = {
  IOS: 'IOS',
  ANDROID: 'ANDROID'
} as const

export type MobilePlatform = (typeof MobilePlatform)[keyof typeof MobilePlatform]


export const TransactionalPushNotificationType = {
  TWO_WEEKS_AFTER_CONSULTATION_IF_NO_FOLLOWUP_APPOINTMENT_BOOKED: 'TWO_WEEKS_AFTER_CONSULTATION_IF_NO_FOLLOWUP_APPOINTMENT_BOOKED',
  ONE_DAY_AFTER_TREATMENT_PLANNER_CREATED_IF_NOT_VIEWED: 'ONE_DAY_AFTER_TREATMENT_PLANNER_CREATED_IF_NOT_VIEWED',
  AFTER_TREATMENT_FEEDBACK_REQUEST: 'AFTER_TREATMENT_FEEDBACK_REQUEST',
  CUSTOMER_BLOOD_REPORT_READY: 'CUSTOMER_BLOOD_REPORT_READY'
} as const

export type TransactionalPushNotificationType = (typeof TransactionalPushNotificationType)[keyof typeof TransactionalPushNotificationType]


export const CustomerDocumentType = {
  ANAMNESE: 'ANAMNESE',
  INFORMED_CONSENT: 'INFORMED_CONSENT',
  BLOOD_REPORT: 'BLOOD_REPORT',
  OTHER: 'OTHER'
} as const

export type CustomerDocumentType = (typeof CustomerDocumentType)[keyof typeof CustomerDocumentType]


export const CustomerBloodReportStatus = {
  READY: 'READY',
  ERROR: 'ERROR',
  PENDING: 'PENDING'
} as const

export type CustomerBloodReportStatus = (typeof CustomerBloodReportStatus)[keyof typeof CustomerBloodReportStatus]


export const BloodSampleEventType = {
  ORDER_SHIPPED: 'ORDER_SHIPPED',
  ORDER_DELIVERED: 'ORDER_DELIVERED',
  SAMPLE_ARRIVED: 'SAMPLE_ARRIVED',
  RESULTS_AVAILABLE: 'RESULTS_AVAILABLE',
  RESULTS_NOT_MEASURABLE: 'RESULTS_NOT_MEASURABLE'
} as const

export type BloodSampleEventType = (typeof BloodSampleEventType)[keyof typeof BloodSampleEventType]


export const TreatmentCourseStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
} as const

export type TreatmentCourseStatus = (typeof TreatmentCourseStatus)[keyof typeof TreatmentCourseStatus]


export const EquipmentScheduleEntryType = {
  AVAILABLE: 'AVAILABLE',
  BLOCKED: 'BLOCKED'
} as const

export type EquipmentScheduleEntryType = (typeof EquipmentScheduleEntryType)[keyof typeof EquipmentScheduleEntryType]


export const PractitionerScheduleEntryType = {
  AVAILABLE: 'AVAILABLE',
  BLOCKED: 'BLOCKED'
} as const

export type PractitionerScheduleEntryType = (typeof PractitionerScheduleEntryType)[keyof typeof PractitionerScheduleEntryType]


export const PractitionerScheduleEntryBlockedType = {
  BREAK: 'BREAK',
  VACATION: 'VACATION',
  MEETING: 'MEETING',
  SICK_LEAVE: 'SICK_LEAVE',
  EDUCATION: 'EDUCATION',
  OTHER: 'OTHER'
} as const

export type PractitionerScheduleEntryBlockedType = (typeof PractitionerScheduleEntryBlockedType)[keyof typeof PractitionerScheduleEntryBlockedType]


export const StoreScheduleEntryType = {
  AVAILABLE: 'AVAILABLE',
  BLOCKED: 'BLOCKED'
} as const

export type StoreScheduleEntryType = (typeof StoreScheduleEntryType)[keyof typeof StoreScheduleEntryType]


export const StoreScheduleEntryBlockedType = {
  BREAK: 'BREAK',
  VACATION: 'VACATION',
  MEETING: 'MEETING',
  SICK_LEAVE: 'SICK_LEAVE',
  EDUCATION: 'EDUCATION',
  OTHER: 'OTHER'
} as const

export type StoreScheduleEntryBlockedType = (typeof StoreScheduleEntryBlockedType)[keyof typeof StoreScheduleEntryBlockedType]


export const ServicePillarType = {
  AESTHETIC: 'AESTHETIC',
  COSMETIC: 'COSMETIC',
  HEALTH: 'HEALTH'
} as const

export type ServicePillarType = (typeof ServicePillarType)[keyof typeof ServicePillarType]


export const ServiceMedicalType = {
  MEDICAL: 'MEDICAL',
  NOT_MEDICAL: 'NOT_MEDICAL'
} as const

export type ServiceMedicalType = (typeof ServiceMedicalType)[keyof typeof ServiceMedicalType]


export const GoaBillingType = {
  STATIC: 'STATIC',
  DYNAMIC: 'DYNAMIC'
} as const

export type GoaBillingType = (typeof GoaBillingType)[keyof typeof GoaBillingType]


export const GiftCardTemplateType = {
  USE_EVERYWHERE: 'USE_EVERYWHERE',
  USE_LIMITED_TREATMENT_VARIANTS: 'USE_LIMITED_TREATMENT_VARIANTS'
} as const

export type GiftCardTemplateType = (typeof GiftCardTemplateType)[keyof typeof GiftCardTemplateType]


export const AppointmentStatus = {
  REQUESTED: 'REQUESTED',
  DECLINED: 'DECLINED',
  SCHEDULED: 'SCHEDULED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  NO_SHOW: 'NO_SHOW',
  CALLED_OFF: 'CALLED_OFF'
} as const

export type AppointmentStatus = (typeof AppointmentStatus)[keyof typeof AppointmentStatus]


export const AppointmentModifiedReasonType = {
  CUSTOMER_CANCELLED: 'CUSTOMER_CANCELLED',
  CUSTOMER_MOVED: 'CUSTOMER_MOVED',
  COMPANY_CANCELLED: 'COMPANY_CANCELLED',
  COMPANY_MOVED: 'COMPANY_MOVED',
  COMPANY_DECLINED: 'COMPANY_DECLINED',
  COMPANY_CALLED_OFF: 'COMPANY_CALLED_OFF'
} as const

export type AppointmentModifiedReasonType = (typeof AppointmentModifiedReasonType)[keyof typeof AppointmentModifiedReasonType]


export const PaymentMethod = {
  GHL_PAYMENT_LINK: 'GHL_PAYMENT_LINK',
  GHL_MANUAL_PAYMENT: 'GHL_MANUAL_PAYMENT',
  BANK_TRANSFER: 'BANK_TRANSFER',
  CASH: 'CASH',
  CARD_TERMINAL_STRIPE: 'CARD_TERMINAL_STRIPE',
  GIFT_CARD: 'GIFT_CARD',
  BUNDLE_VOUCHER: 'BUNDLE_VOUCHER',
  KLARNA: 'KLARNA',
  STRIPE_CHECKOUT: 'STRIPE_CHECKOUT',
  SUMUP: 'SUMUP',
  PAYPAL: 'PAYPAL'
} as const

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]


export const PaymentType = {
  BILLING_DRAFT_PAYMENT: 'BILLING_DRAFT_PAYMENT',
  BILLING_DRAFT_REFUND: 'BILLING_DRAFT_REFUND',
  INVOICE_PAYMENT: 'INVOICE_PAYMENT'
} as const

export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType]


export const PaymentStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus]


export const BundleVoucherTransactionType = {
  REDEMPTION: 'REDEMPTION',
  REFUND: 'REFUND',
  ADJUSTMENT: 'ADJUSTMENT'
} as const

export type BundleVoucherTransactionType = (typeof BundleVoucherTransactionType)[keyof typeof BundleVoucherTransactionType]


export const GiftCardTransactionType = {
  REDEMPTION: 'REDEMPTION',
  REFUND: 'REFUND',
  ADJUSTMENT: 'ADJUSTMENT'
} as const

export type GiftCardTransactionType = (typeof GiftCardTransactionType)[keyof typeof GiftCardTransactionType]


export const AppointmentLiveBoardGroup = {
  INITIAL: 'INITIAL',
  ARRIVED: 'ARRIVED',
  SKINSCANNER: 'SKINSCANNER',
  PREPARATION: 'PREPARATION',
  TREATMENT: 'TREATMENT',
  FINALIZING: 'FINALIZING'
} as const

export type AppointmentLiveBoardGroup = (typeof AppointmentLiveBoardGroup)[keyof typeof AppointmentLiveBoardGroup]


export const WaitlistDesiredTimeOfDay = {
  MORNING: 'MORNING',
  AFTERNOON: 'AFTERNOON',
  EVENING: 'EVENING'
} as const

export type WaitlistDesiredTimeOfDay = (typeof WaitlistDesiredTimeOfDay)[keyof typeof WaitlistDesiredTimeOfDay]


export const WaitlistCallStatus = {
  CALLED: 'CALLED',
  NOT_REACHED: 'NOT_REACHED',
  CONTACTED: 'CONTACTED'
} as const

export type WaitlistCallStatus = (typeof WaitlistCallStatus)[keyof typeof WaitlistCallStatus]


export const FederalState = {
  BW: 'BW',
  BY: 'BY',
  BE: 'BE',
  BB: 'BB',
  HB: 'HB',
  HE: 'HE',
  HH: 'HH',
  MV: 'MV',
  NI: 'NI',
  NW: 'NW',
  RP: 'RP',
  SL: 'SL',
  SN: 'SN',
  ST: 'ST',
  SH: 'SH',
  TH: 'TH'
} as const

export type FederalState = (typeof FederalState)[keyof typeof FederalState]


export const Timezone = {
  Europe_Berlin: 'Europe_Berlin',
  Europe_Lisbon: 'Europe_Lisbon',
  Europe_London: 'Europe_London',
  Europe_Paris: 'Europe_Paris',
  Europe_Athens: 'Europe_Athens',
  Europe_Moscow: 'Europe_Moscow',
  Europe_Istanbul: 'Europe_Istanbul',
  Asia_Dubai: 'Asia_Dubai',
  Asia_Kolkata: 'Asia_Kolkata',
  Asia_Bangkok: 'Asia_Bangkok',
  Asia_Singapore: 'Asia_Singapore',
  Asia_Tokyo: 'Asia_Tokyo',
  Asia_Seoul: 'Asia_Seoul',
  Australia_Sydney: 'Australia_Sydney',
  Pacific_Auckland: 'Pacific_Auckland',
  Pacific_Honolulu: 'Pacific_Honolulu',
  America_Anchorage: 'America_Anchorage',
  America_Los_Angeles: 'America_Los_Angeles',
  America_Denver: 'America_Denver',
  America_Chicago: 'America_Chicago',
  America_New_York: 'America_New_York',
  America_Sao_Paulo: 'America_Sao_Paulo',
  America_Buenos_Aires: 'America_Buenos_Aires',
  Atlantic_Reykjavik: 'Atlantic_Reykjavik',
  Africa_Cairo: 'Africa_Cairo',
  Africa_Johannesburg: 'Africa_Johannesburg'
} as const

export type Timezone = (typeof Timezone)[keyof typeof Timezone]


export const UserTaskStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  DISMISSED: 'DISMISSED'
} as const

export type UserTaskStatus = (typeof UserTaskStatus)[keyof typeof UserTaskStatus]


export const CashRegisterTransactionType = {
  TRANSFER_TO_OTHER_CASH_REGISTER: 'TRANSFER_TO_OTHER_CASH_REGISTER',
  TRANSFER_FROM_OTHER_CASH_REGISTER: 'TRANSFER_FROM_OTHER_CASH_REGISTER',
  PAYMENT: 'PAYMENT',
  WITHDRAWAL: 'WITHDRAWAL',
  UNDO_WITHDRAWAL: 'UNDO_WITHDRAWAL',
  DEPOSIT: 'DEPOSIT'
} as const

export type CashRegisterTransactionType = (typeof CashRegisterTransactionType)[keyof typeof CashRegisterTransactionType]


export const resource_availability_resourceType = {
  PRACTITIONER: 'PRACTITIONER',
  ROOM: 'ROOM',
  EQUIPMENT: 'EQUIPMENT'
} as const

export type resource_availability_resourceType = (typeof resource_availability_resourceType)[keyof typeof resource_availability_resourceType]


export const resource_allocation_resourceType = {
  PRACTITIONER: 'PRACTITIONER',
  ROOM: 'ROOM',
  EQUIPMENT: 'EQUIPMENT'
} as const

export type resource_allocation_resourceType = (typeof resource_allocation_resourceType)[keyof typeof resource_allocation_resourceType]


export const product_price_customerType = {
  STANDARD: 'STANDARD',
  PREMIUM: 'PREMIUM'
} as const

export type product_price_customerType = (typeof product_price_customerType)[keyof typeof product_price_customerType]


export const resource_allocation_resourceBlockerType = {
  APPOINTMENT_PRODUCT: 'APPOINTMENT_PRODUCT',
  BLOCKER: 'BLOCKER'
} as const

export type resource_allocation_resourceBlockerType = (typeof resource_allocation_resourceBlockerType)[keyof typeof resource_allocation_resourceBlockerType]


export const resource_availability_resourceOwnerType = {
  STORE: 'STORE'
} as const

export type resource_availability_resourceOwnerType = (typeof resource_availability_resourceOwnerType)[keyof typeof resource_availability_resourceOwnerType]


export const equipment_status = {
  AVAILABLE: 'AVAILABLE',
  DEFECT: 'DEFECT'
} as const

export type equipment_status = (typeof equipment_status)[keyof typeof equipment_status]


export const coupon_customerType = {
  STANDARD: 'STANDARD',
  PREMIUM: 'PREMIUM'
} as const

export type coupon_customerType = (typeof coupon_customerType)[keyof typeof coupon_customerType]


export const appointment_appointmentStatus = {
  NEW: 'NEW',
  PRESENT: 'PRESENT',
  CANCELLED: 'CANCELLED',
  CANCELLED_BY_CUSTOMER: 'CANCELLED_BY_CUSTOMER',
  ABSENT: 'ABSENT',
  ACCOMPLISHED: 'ACCOMPLISHED',
  RESCHEDULED_BY_KALIALAB: 'RESCHEDULED_BY_KALIALAB',
  RESCHEDULED_BY_CUSTOMER: 'RESCHEDULED_BY_CUSTOMER',
  TREATMENT_PREPARED: 'TREATMENT_PREPARED',
  NO_SHOW: 'NO_SHOW',
  CONFIRMED: 'CONFIRMED',
  CONFIRMED_WITH_VIRTUAL_PRACTITIONER: 'CONFIRMED_WITH_VIRTUAL_PRACTITIONER',
  CUSTOMER_ARRIVED: 'CUSTOMER_ARRIVED',
  INITIAL: 'INITIAL',
  ARRIVED: 'ARRIVED',
  SKINSCANNER: 'SKINSCANNER',
  TREATMENT: 'TREATMENT',
  FINALIZING: 'FINALIZING'
} as const

export type appointment_appointmentStatus = (typeof appointment_appointmentStatus)[keyof typeof appointment_appointmentStatus]


export const customer_role = {
  CUSTOMER: 'CUSTOMER',
  USER: 'USER',
  ADMIN: 'ADMIN'
} as const

export type customer_role = (typeof customer_role)[keyof typeof customer_role]


export const coupon_usageType = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE'
} as const

export type coupon_usageType = (typeof coupon_usageType)[keyof typeof coupon_usageType]


export const appointment_bookingChannel = {
  BOOKING_TRACK: 'BOOKING_TRACK',
  PERSONAL: 'PERSONAL',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  WALK_IN: 'WALK_IN',
  TELEPHONE: 'TELEPHONE'
} as const

export type appointment_bookingChannel = (typeof appointment_bookingChannel)[keyof typeof appointment_bookingChannel]


export const PractitionerType = {
  DOCTOR: 'DOCTOR',
  COSMETICIAN: 'COSMETICIAN',
  MFA: 'MFA'
} as const

export type PractitionerType = (typeof PractitionerType)[keyof typeof PractitionerType]


export const user_role = {
  ADMIN: 'ADMIN',
  OPERATOR: 'OPERATOR',
  USER: 'USER',
  CUSTOMER: 'CUSTOMER'
} as const

export type user_role = (typeof user_role)[keyof typeof user_role]


export const Permission = {
  READ_PATIENT_MEDICAL_RECORD: 'READ_PATIENT_MEDICAL_RECORD',
  WRITE_PATIENT_MEDICAL_RECORD: 'WRITE_PATIENT_MEDICAL_RECORD',
  DELETE_PATIENT_MEDICAL_RECORD: 'DELETE_PATIENT_MEDICAL_RECORD',
  READ_PATIENT_BLOOD_RESULTS: 'READ_PATIENT_BLOOD_RESULTS',
  WRITE_PATIENT_BLOOD_RESULTS: 'WRITE_PATIENT_BLOOD_RESULTS',
  READ_INVOICES: 'READ_INVOICES',
  WRITE_INVOICES: 'WRITE_INVOICES',
  READ_APPOINTMENTS: 'READ_APPOINTMENTS',
  WRITE_APPOINTMENTS: 'WRITE_APPOINTMENTS',
  READ_CUSTOMERS: 'READ_CUSTOMERS',
  WRITE_CUSTOMERS: 'WRITE_CUSTOMERS',
  MANAGE_PERMISSIONS: 'MANAGE_PERMISSIONS',
  MANAGE_USERS: 'MANAGE_USERS',
  MANAGE_ROLES: 'MANAGE_ROLES'
} as const

export type Permission = (typeof Permission)[keyof typeof Permission]


export const customer_country = {
  GERMANY: 'GERMANY',
  FRANCE: 'FRANCE',
  ITALY: 'ITALY',
  SPAIN: 'SPAIN',
  PORTUGAL: 'PORTUGAL',
  NETHERLANDS: 'NETHERLANDS',
  BELGIUM: 'BELGIUM',
  LUXEMBOURG: 'LUXEMBOURG',
  SWITZERLAND: 'SWITZERLAND',
  AUSTRIA: 'AUSTRIA',
  UNITED_KINGDOM: 'UNITED_KINGDOM',
  IRELAND: 'IRELAND',
  DENMARK: 'DENMARK',
  NORWAY: 'NORWAY',
  SWEDEN: 'SWEDEN',
  FINLAND: 'FINLAND',
  ENGLAND: 'ENGLAND',
  SCOTLAND: 'SCOTLAND',
  WALES: 'WALES',
  NORTHERN_IRELAND: 'NORTHERN_IRELAND',
  UNITED_STATES: 'UNITED_STATES',
  CANADA: 'CANADA'
} as const

export type customer_country = (typeof customer_country)[keyof typeof customer_country]


export const resource_availability_resourcePresenceType = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL'
} as const

export type resource_availability_resourcePresenceType = (typeof resource_availability_resourcePresenceType)[keyof typeof resource_availability_resourcePresenceType]


export const practitioner_presenceType = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL'
} as const

export type practitioner_presenceType = (typeof practitioner_presenceType)[keyof typeof practitioner_presenceType]


export const resource_allocation_resourceAllocatorType = {
  APPOINTMENT: 'APPOINTMENT'
} as const

export type resource_allocation_resourceAllocatorType = (typeof resource_allocation_resourceAllocatorType)[keyof typeof resource_allocation_resourceAllocatorType]


export const coupon_couponType = {
  PERCENTAGE: 'PERCENTAGE',
  AMOUNT: 'AMOUNT'
} as const

export type coupon_couponType = (typeof coupon_couponType)[keyof typeof coupon_couponType]


export const customer_preferredCommunicationType = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP'
} as const

export type customer_preferredCommunicationType = (typeof customer_preferredCommunicationType)[keyof typeof customer_preferredCommunicationType]


export const resource_allocation_resourcePresenceType = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL'
} as const

export type resource_allocation_resourcePresenceType = (typeof resource_allocation_resourcePresenceType)[keyof typeof resource_allocation_resourcePresenceType]


export const customer_category = {
  STANDARD: 'STANDARD',
  PREMIUM: 'PREMIUM'
} as const

export type customer_category = (typeof customer_category)[keyof typeof customer_category]


export const ActivationIdStatus = {
  AVAILABLE: 'AVAILABLE',
  ASSIGNED: 'ASSIGNED',
  USED: 'USED',
  LOST: 'LOST',
  EXPIRED: 'EXPIRED'
} as const

export type ActivationIdStatus = (typeof ActivationIdStatus)[keyof typeof ActivationIdStatus]


export const AppointmentsCalendarConfigResourceType = {
  NOT_ASSIGNED: 'NOT_ASSIGNED',
  PROCESSING_TIME: 'PROCESSING_TIME',
  RECEPTION: 'RECEPTION',
  PRACTITIONER: 'PRACTITIONER',
  DEVICE: 'DEVICE',
  ROOM: 'ROOM'
} as const

export type AppointmentsCalendarConfigResourceType = (typeof AppointmentsCalendarConfigResourceType)[keyof typeof AppointmentsCalendarConfigResourceType]


export const BookingFunnelBookableItemType = {
  SERVICE: 'SERVICE',
  BUNDLE: 'BUNDLE'
} as const

export type BookingFunnelBookableItemType = (typeof BookingFunnelBookableItemType)[keyof typeof BookingFunnelBookableItemType]


export const BookingFunnelTagColor = {
  BURGUNDY: 'BURGUNDY',
  ROSE: 'ROSE',
  GREEN: 'GREEN',
  BLUE: 'BLUE',
  AMBER: 'AMBER',
  PURPLE: 'PURPLE',
  GRAY: 'GRAY',
  NAVY: 'NAVY',
  ORANGE: 'ORANGE',
  PEACH: 'PEACH',
  SAND: 'SAND'
} as const

export type BookingFunnelTagColor = (typeof BookingFunnelTagColor)[keyof typeof BookingFunnelTagColor]


export const CartItemSource = {
  CUSTOMER: 'CUSTOMER',
  CLINIC_UPSELL: 'CLINIC_UPSELL'
} as const

export type CartItemSource = (typeof CartItemSource)[keyof typeof CartItemSource]


export const Currency = {
  EUR: 'EUR'
} as const

export type Currency = (typeof Currency)[keyof typeof Currency]


export const BillingDraftType = {
  NORMAL: 'NORMAL',
  INFLUENCER: 'INFLUENCER',
  MARKETING: 'MARKETING',
  ACADEMY: 'ACADEMY',
  KULANZ: 'KULANZ',
  CANCELLATION_FEE: 'CANCELLATION_FEE'
} as const

export type BillingDraftType = (typeof BillingDraftType)[keyof typeof BillingDraftType]


export const BillingDraftStatus = {
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED'
} as const

export type BillingDraftStatus = (typeof BillingDraftStatus)[keyof typeof BillingDraftStatus]


export const InfluencerType = {
  BEAUTY_INSIDER: 'BEAUTY_INSIDER',
  INFLUENCER: 'INFLUENCER',
  INFLUENCER_FLATRATE: 'INFLUENCER_FLATRATE'
} as const

export type InfluencerType = (typeof InfluencerType)[keyof typeof InfluencerType]


export const BillingDraftLineItemSource = {
  ORIGINATED_FROM_CUSTOMER_BOOKED_CART: 'ORIGINATED_FROM_CUSTOMER_BOOKED_CART',
  UPSELL: 'UPSELL',
  PHYSICAL_PRODUCT: 'PHYSICAL_PRODUCT',
  BUNDLE_FIRST_CHARGE: 'BUNDLE_FIRST_CHARGE',
  CANCELLATION_FEE: 'CANCELLATION_FEE'
} as const

export type BillingDraftLineItemSource = (typeof BillingDraftLineItemSource)[keyof typeof BillingDraftLineItemSource]


export const CancellationFeeType = {
  NO_SHOW: 'NO_SHOW',
  LATE_CANCELLATION: 'LATE_CANCELLATION'
} as const

export type CancellationFeeType = (typeof CancellationFeeType)[keyof typeof CancellationFeeType]


export const BillingDraftLineItemStatus = {
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED'
} as const

export type BillingDraftLineItemStatus = (typeof BillingDraftLineItemStatus)[keyof typeof BillingDraftLineItemStatus]


export const InvoiceType = {
  GOA_INVOICE: 'GOA_INVOICE',
  GOA_REFUND_INVOICE: 'GOA_REFUND_INVOICE',
  BUNDLE_INVOICE: 'BUNDLE_INVOICE',
  BUNDLE_REFUND_INVOICE: 'BUNDLE_REFUND_INVOICE',
  GIFT_CARD_INVOICE: 'GIFT_CARD_INVOICE',
  GIFT_CARD_REFUND_INVOICE: 'GIFT_CARD_REFUND_INVOICE',
  GENERAL_INVOICE: 'GENERAL_INVOICE',
  GENERAL_REFUND_INVOICE: 'GENERAL_REFUND_INVOICE',
  AUSFALL_INVOICE: 'AUSFALL_INVOICE',
  AUSFALL_REFUND_INVOICE: 'AUSFALL_REFUND_INVOICE'
} as const

export type InvoiceType = (typeof InvoiceType)[keyof typeof InvoiceType]


export const MedicalRecordImageUploadType = {
  UPLOADED_BY_PRACTITIONER: 'UPLOADED_BY_PRACTITIONER',
  UPLOADED_BY_CUSTOMER: 'UPLOADED_BY_CUSTOMER'
} as const

export type MedicalRecordImageUploadType = (typeof MedicalRecordImageUploadType)[keyof typeof MedicalRecordImageUploadType]


export const MedicalRecordImageType = {
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  OTHER: 'OTHER',
  COMPLICATION: 'COMPLICATION'
} as const

export type MedicalRecordImageType = (typeof MedicalRecordImageType)[keyof typeof MedicalRecordImageType]


export const MedicalRecordTreatmentStep = {
  ATTRIBUTION_STEP: 'ATTRIBUTION_STEP',
  MEDICAL_DOCUMENTATION_STEP: 'MEDICAL_DOCUMENTATION_STEP'
} as const

export type MedicalRecordTreatmentStep = (typeof MedicalRecordTreatmentStep)[keyof typeof MedicalRecordTreatmentStep]


export const MedicalRecordNoTreatmentReason = {
  CURRENT_ANAMNESE: 'CURRENT_ANAMNESE',
  EXTERNAL_FACTORS: 'EXTERNAL_FACTORS',
  CONTRAINDICATION: 'CONTRAINDICATION',
  BODY_DYSMORPHIC_DISORDER: 'BODY_DYSMORPHIC_DISORDER',
  INSUFFICIENT_TIME: 'INSUFFICIENT_TIME',
  OTHER: 'OTHER'
} as const

export type MedicalRecordNoTreatmentReason = (typeof MedicalRecordNoTreatmentReason)[keyof typeof MedicalRecordNoTreatmentReason]


export const DiscountCodeType = {
  ABSOLUTE_DISCOUNT: 'ABSOLUTE_DISCOUNT',
  PERCENTAGE_DISCOUNT: 'PERCENTAGE_DISCOUNT'
} as const

export type DiscountCodeType = (typeof DiscountCodeType)[keyof typeof DiscountCodeType]


export const DiscountCodeApplicationLevel = {
  PER_LINE_ITEM: 'PER_LINE_ITEM',
  ENTIRE_PURCHASE: 'ENTIRE_PURCHASE'
} as const

export type DiscountCodeApplicationLevel = (typeof DiscountCodeApplicationLevel)[keyof typeof DiscountCodeApplicationLevel]


export const DiscountCodeApplicationCustomerType = {
  NEW_CUSTOMERS_ONLY: 'NEW_CUSTOMERS_ONLY',
  RETURNING_CUSTOMERS_ONLY: 'RETURNING_CUSTOMERS_ONLY',
  ALL_CUSTOMERS: 'ALL_CUSTOMERS'
} as const

export type DiscountCodeApplicationCustomerType = (typeof DiscountCodeApplicationCustomerType)[keyof typeof DiscountCodeApplicationCustomerType]


export const KlarnaAuthorizationStatus = {
  PENDING_AUTHORIZATION: 'PENDING_AUTHORIZATION',
  AUTHORIZED: 'AUTHORIZED',
  CAPTURED: 'CAPTURED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  DECLINED: 'DECLINED'
} as const

export type KlarnaAuthorizationStatus = (typeof KlarnaAuthorizationStatus)[keyof typeof KlarnaAuthorizationStatus]


export const PractitionerAvailabilityShiftType = {
  MORNING: 'MORNING',
  AFTERNOON: 'AFTERNOON',
  EVENING: 'EVENING',
  SATURDAY: 'SATURDAY'
} as const

export type PractitionerAvailabilityShiftType = (typeof PractitionerAvailabilityShiftType)[keyof typeof PractitionerAvailabilityShiftType]


export const PractitionerUtilizationEventType = {
  BLOCKER: 'BLOCKER',
  APPOINTMENT: 'APPOINTMENT'
} as const

export type PractitionerUtilizationEventType = (typeof PractitionerUtilizationEventType)[keyof typeof PractitionerUtilizationEventType]


export const BookabilityCheckRunStatus = {
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type BookabilityCheckRunStatus = (typeof BookabilityCheckRunStatus)[keyof typeof BookabilityCheckRunStatus]


export const BookabilityCheckTrigger = {
  CRON: 'CRON',
  MANUAL: 'MANUAL'
} as const

export type BookabilityCheckTrigger = (typeof BookabilityCheckTrigger)[keyof typeof BookabilityCheckTrigger]


export const BookabilityCheckResultStatus = {
  OK: 'OK',
  LOW: 'LOW',
  NONE: 'NONE',
  ERROR: 'ERROR'
} as const

export type BookabilityCheckResultStatus = (typeof BookabilityCheckResultStatus)[keyof typeof BookabilityCheckResultStatus]
